"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "viernes",
    "MONDAY": "lunes",
    "SATURDAY": "sábado",
    "SUNDAY": "domingo",
    "THURSDAY": "jueves",
    "TUESDAY": "martes",
    "WEDNESDAY": "miércoles",
    "and": "y",
    "day": "día",
    "day_many": "dias",
    "day_one": "día",
    "day_other": "dias",
    "day_plural": "dias",
    "freeOfCharge": "Gratis",
    "hour_one": "hora",
    "hour_one_plural": "horas",
    "hour_other": "horas",
    "minute": "minuto",
    "minute_many": "minuto",
    "minute_one": "minuto",
    "minute_other": "minutos",
    "ocpiRestrictionsAfterDuration": "Después de {{minDuration}}",
    "ocpiRestrictionsBetweenDuration": "Entre {{minDuration}} y {{maxDuration}}",
    "ocpiRestrictionsFirstDuration": "Primero {{maxDuration}}",
    "ocpiRestrictionsKwhAbove": "Cuando el consumo de energía supera los {{minKwh}}",
    "ocpiRestrictionsKwhBetween": "Cuando el consumo de energía entre {{minKwh}} y {{maxKwh}}",
    "ocpiRestrictionsKwhLessThan": "Cuando el consumo de energía es inferior a {{maxKwh}}",
    "session": "sesión",
    "theDay_many": "día",
    "theDay_one": "día",
    "theDay_other": "dias",
    "theHour_many": "hora",
    "theHour_one": "hora",
    "theHour_other": "horas",
    "theMinute_many": "minuto",
    "theMinute_one": "minuto",
    "theMinute_other": "minutos"
};
